import { FileBase } from '../FileBase';
import { StringBase } from '../StringBase';
import _ from 'underscore';
export class AudienceNotes extends FileBase {

  keywords = null;


  isValid() {
    return (this.keywords && this.keywords.length > 0) || super.isValid();
  }

  static count(target) {
    let len = 0;
    if (target && target.keywords) {
      len = StringBase.count(target.keywords);
    }
    if (target && target.uploaded && _.isObject(target.uploaded)) {
      len += 1;
    }
    return len;
  }
}
